import { render } from "./lowSales.vue?vue&type=template&id=f626e04e&scoped=true"
import script from "./lowSales.vue?vue&type=script&lang=js"
export * from "./lowSales.vue?vue&type=script&lang=js"

import "./lowSales.vue?vue&type=style&index=0&id=f626e04e&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f626e04e"]])

export default __exports__